import { render, staticRenderFns } from "./legalNotice.vue?vue&type=template&id=4c07a2f2&scoped=true"
import script from "./legalNotice.vue?vue&type=script&lang=js"
export * from "./legalNotice.vue?vue&type=script&lang=js"
import style0 from "./legalNotice.vue?vue&type=style&index=0&id=4c07a2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07a2f2",
  null
  
)

export default component.exports